import PropTypes from "prop-types";
// @mui
import Main from "./Main";
import Header from "./header";
import Navigation from "./nav";
import FooterMenu from "@/src/modules/home/footer/footerMenu";
import MarqueeWithClose from "./header/marquee";
import { headerApiService } from "@/src/lib/api-services/headerApiServices";
import { useMemo } from "react";

import Progressbar from "../loading";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
// ----------------------------------------------------------------------

const STATIC_MENU_ITEMS =
    "Experience Home Collections in as early as 45 minutes* when you book with us online. *Subject to slot availability";

DashboardLayout.propTypes = {
    children: PropTypes.node,
};

export default function DashboardLayout({ children }) {
    const isNotDesktop = useBreakpoint("lg");

    const { data, isLoading } = useCustomQuery(
        "menu",
        headerApiService.getNavigation,
        {
            enabled: true,
            staleTime: 1000 * 60 * 60 * 24, // 24 hours fresh data
        }
    );

    const menuItems = useMemo(() => {
        if (data) {
            return data.data;
        }
    }, [data]);

    return (
        <>
            <MarqueeWithClose
                announcement={
                    !!menuItems?.announcement
                        ? menuItems?.announcement
                        : { announcement: STATIC_MENU_ITEMS }
                }
            />
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1100,
                    backgroundColor: "white",
                }}
                className="md:h-[64px] h-auto"
            >
                <Header />
            </div>

            {!isNotDesktop && (
                <div
                    style={{
                        position: "sticky",
                        top: "64px",
                        zIndex: 1000,
                        backgroundColor: "white",
                    }}
                >
                    <div className="bg-white  border-t-gray-200 relative z-10 md:block hidden md:h-[48px] h-auto">
                        {isLoading ? (
                            <div className="flex justify-center items-center ">
                                <Progressbar />
                            </div>
                        ) : (
                            <Navigation menuItems={menuItems} />
                        )}
                    </div>
                </div>
            )}

            <Main>{children}</Main>

            <FooterMenu />
        </>
    );
}
